import type { VariantProps } from 'class-variance-authority'
import type { ButtonHTMLAttributes } from 'react'

import { buttonVariants } from '@/components/ui/button-variants'
import { cn } from '@/lib/utils'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>

/**
 * `type="button"` unless the caller says otherwise, as IconButton, Chip and
 * SelectTrigger do: the HTML default is `submit`, so a bare Button inside a
 * form submits it.
 */
export default function Button({ className, variant, size, shape, ...props }: ButtonProps) {
  return (
    <button
      type="button"
      className={cn(buttonVariants({ variant, size, shape }), className)}
      {...props}
    />
  )
}
